import React, { useState } from "react";
import { withModal } from "../";

const criteria = {
  "First name": { key: "firstName" },
  "Last name": { key: "lastName" },
  "Postal code": { key: "zip" },
  "Phone number": { key: "phoneNumber" },
  "Email address": { key: "email" }
};

const LinkBankWarningsDetailsModal = ({
  context: { closeModal },
  accountWarnings = [],
  ...rest
}) => {
  const [expandedIndices, setExpandedIndices] = useState([]);

  const toggleIndex = i => {
    const index = expandedIndices.indexOf(i);
    if (index === -1) {
      setExpandedIndices([...expandedIndices, i]);
    } else {
      setExpandedIndices([...expandedIndices.filter((e, i) => i !== index)]);
    }
  };

  return (
    <div
      className="relative bg-white outline-none w-auto h-auto p-10 max-h-screen overflow-auto"
      style={{ maxHeight: 600 }}
    >
      <div className="text-center text-3xl">{`Account Mismatch Details`}</div>
      <div className="w-5/6 m-auto pt-4">
        <p className="max-w-xl">
          Looks like some of the information you provided does not match one or
          more of your bank accounts. You may want to call your bank to update
          or confirm the following information. If you choose to continue
          without resolving, please be aware that it may cause delays with your
          application.
        </p>
        <ul className="list-disc py-4">
          {accountWarnings.map((e, i) => {
            const { account: { nickname, mask } = {}, details, error } = e;
            return (
              <div
                className="bg-red-100 px-4 py-2 rounded mb-2"
                onClick={() => toggleIndex(i)}
              >
                <div className="flex justify-between">
                  <div className="font-bold">{`${nickname} (*${mask})`}</div>
                  <div className="p-1">
                    {details && (
                      <i
                        className={`fas fa-chevron-${
                          expandedIndices.includes(i) ? "up" : "down"
                        }`}
                      />
                    )}
                  </div>
                </div>
                <div className={expandedIndices.includes(i) ? "" : "hidden"}>
                  {/*<div>{`${error}`}</div>*/}
                  {details && (
                    <div className="ml-4">
                      {Object.keys(details).map(d => (
                        <div>
                          <div
                            style={{ width: 24, height: 16 }}
                            className="inline-block pr-2 text-center"
                          >
                            <i
                              className={
                                details[d]
                                  ? "fas fa-check text-green-500"
                                  : "fas fa-times text-red-500"
                              }
                            ></i>
                          </div>
                          {Object.keys(criteria)
                            .filter(k => criteria[k].key === d)
                            .pop()}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </ul>
        <div
          className="p4 text-center underline cursor-pointer"
          onClick={closeModal}
        >
          I understand
        </div>
      </div>
      <button
        style={{ outline: "none" }}
        className="absolute top-0 right-0 text-2xl m-1 mt-2 mr-2 w-10 h-10 outline-none"
        onClick={closeModal}
      >
        <i class="fal fa-times-circle"></i>
      </button>
    </div>
  );
};

export default withModal(LinkBankWarningsDetailsModal);
